export default __webpack_public_path__ + "static/media/holyvengeance.b0af354e.png";